import { Component, Inject } from '@angular/core';
import { DocumentData } from '../../document.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from '../../dashboard.service';
import { CommonService } from 'src/app/services/common.service';
import { NotificationService } from 'src/app/services/notification.service';
import Swal from 'sweetalert2';
import { helper } from 'src/environments/helper';
import { debounceTime, finalize, map, Subject } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';

interface Sursa {
    id: number,
    name: string,
}

@Component({
    selector: 'app-edit-info',
    templateUrl: './edit-info.component.html',
    styleUrls: ['./edit-info.component.scss']
})
export class EditInfoComponent {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    isLoading = false;

    docData: DocumentData | null = null;

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    form: FormGroup = new FormGroup({
        source: new FormControl(-1, []),
        // sourceArr: this.fb.array([]), // Added in submitForm!
        id_tip_document: new FormControl(null, [Validators.required]),
        name_tip_document: new FormControl('', [Validators.required]),
        parent_no: new FormControl('', []),
        parent_year: new FormControl(2025, []),
        keywords: new FormControl('', [Validators.required]),
        no_pages: new FormControl('', [Validators.required]),
    });

    private destroy$ = new Subject<void>();

    surse: Generic[] = [];
    sourceArr: Sursa[] = [];

    tipDocumente: Generic[] = [];
    tipDocumenteControl: FormControl<any> = new FormControl('', [Validators.required]);
    isTipDocumenteLoading = false;
    showTipDocumenteMessage = true;
    tipDocumenteLoadComplete = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            docData: DocumentData,
        },
        private dialogRef: MatDialogRef<EditInfoComponent>,
        private dashboardService: DashboardService,
        private commonService: CommonService,
        private notificationService: NotificationService,
    ) {
        this.docData = data.docData;
    }

    ngOnInit() {
        this.loadSurseActive();

        if (this.docData) {
            this.sourceArr = this.docData.sourceArr.map(source => {
                return {
                    id: source.source_id,
                    name: source.nume || '',
                }
            });
            this.tipDocumenteControl.setValue({
                id: this.docData.id_tip_document,
                name: this.docData.info.tip_document,
            });
            this.form.controls['id_tip_document'].patchValue(this.docData.id_tip_document);
            this.form.controls['name_tip_document'].patchValue(this.docData.info.tip_document);
            this.form.controls['parent_no'].patchValue(this.docData.info.parent_no);
            this.form.controls['parent_year'].patchValue(this.docData.info.parent_year);
            this.form.controls['keywords'].patchValue(this.docData.keywords);
            this.form.controls['no_pages'].patchValue(this.docData.no_pages);
        }

        this.tipDocumenteControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(value => {
            if (typeof value === 'string') {
                this.fetchTipDocumente(value);
                this.showTipDocumenteMessage = true;
                this.tipDocumenteLoadComplete = false;
            }
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    loadSurseActive() {
        this.isLoading = true;
        this.commonService
            .getSurseActive()
            .pipe(
                map((resp: Generic[]) => [this.defaultParameter, ...resp]),
                finalize(() => (this.isLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.surse = results;
                },
                error: (error) => {
                    console.error('Error loading surse', error);
                    this.isLoading = false;
                },
            });
    }

    fetchTipDocumente(search: string) {
        if (search && search.length >= 2) {
            this.isTipDocumenteLoading = true;
            this.commonService.searchTipDocumente(search).subscribe({
                next: (response: Generic[]) => {
                    this.tipDocumente = response;
                    this.isTipDocumenteLoading = false;
                    this.tipDocumenteLoadComplete = true;
                    this.showTipDocumenteMessage = this.tipDocumente.length === 0;
                },
                error: (err: any) => {
                    this.isTipDocumenteLoading = false;
                    this.showTipDocumenteMessage = true;
                    this.tipDocumenteLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.tipDocumente = [];
            this.showTipDocumenteMessage = true;
            this.tipDocumenteLoadComplete = false;
        }
    }

    onTipDocumenteSelected(selectedDocument: Generic) {
        if (selectedDocument) {
            this.form.controls['id_tip_document'].patchValue(selectedDocument.id);
            this.form.controls['name_tip_document'].patchValue(selectedDocument.name);
        }
    }

    displayTipDocumente(selectedDocument: Generic): string {
        return selectedDocument && selectedDocument.name ? selectedDocument.name : '';
    }

    onTipDocumenteBlur() {
        const currentValue = this.tipDocumenteControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.tipDocumenteControl.patchValue('');
            this.form.controls['id_tip_document'].patchValue('');
            this.form.controls['name_tip_document'].patchValue('');
        }
    }

    addSerie() {
        const sourceValue: number = this.form.controls['source'].value;

        if (!sourceValue || sourceValue === -1) return;

        const existing = this.sourceArr.find((item: Sursa) => item.id === sourceValue);

        if (existing) {
            return;
        } else {
            const sursa = this.surse.find((item: Generic) => item.id === sourceValue);
            if (sursa) {
                const sourceItem = {
                    id: sursa.id,
                    name: sursa.name,
                }
                this.sourceArr.push(sourceItem);
            };
        }
    }

    removeSerie(index: number) {
        this.sourceArr.splice(index, 1);
    }

    submitForm() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Vă rugăm să confirmați acest proces!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.updateDoc();
            }
        });
    }

    updateDoc() {
        this.isLoading = true;

        const payload = {
            id_tip_document: this.form.value.id_tip_document,
            name_tip_document: this.form.value.name_tip_document,
            parent_no: this.form.value.parent_no,
            parent_year: this.form.value.parent_year,
            keywords: this.form.value.keywords,
            no_pages: this.form.value.no_pages,
            source: null, // Hard coded
            sourceArr: this.sourceArr,
        }

        // console.log(payload);
        this.dashboardService
            .updateInfo(this.docData!.id_document, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    Swal.fire({
                        title: helper.dialogConfig.headers.success,
                        text: 'Info documentație actualizată cu succes',
                        icon: 'success',
                        confirmButtonText: this.helper.dialogConfig.buttonLabels.close,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.dialogRef.close({ success: true });
                        }
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
